import React, { useState, useEffect, useRef } from "react";
import MuiTextField from "@mui/material/TextField";
import useKeyboard from "@shared/modules/utils/Keyboard/useKeyboard";
import EventService from "@shared/services/EventService";
import { scrollFieldIntoViewIfHidden } from "./constants";

const NumberField = React.forwardRef(
    (
        {
            label,
            errorMsg,
            value,
            onChangeInput,
            decimalsAllowed,
            sizeRange,
            minMax,
            containerClass,
            showKeyboard = true,
            enableScrollFieldIfHiddenEvent = true,
            virtualKeyboardLayout = null,
            virtualKeyboardLang = "en",
            ...restProps
        },
        ref
    ) => {
        const [brVal, setBrVal] = useState(true);

        const focusRef = useRef(false); //focus state is "stale" in subscribe event

        useEffect(() => {
            let eventInput = EventService.subscribe("keypad.blur", bool => {
                setBrVal(bool);
            });

            let scrollEvent = enableScrollFieldIfHiddenEvent
                ? EventService.subscribe("keyboard.show", () => {
                    if (focusRef.current) {
                        scrollFieldIntoViewIfHidden(ref);
                    }
                })
                : {};

            return () => {
                eventInput.remove();
                if (scrollEvent.remove) scrollEvent.remove();
            };
        });

        const handleInputChange = newValue => {
            if (isValid(newValue)) {
                onChangeInput(newValue);
            }
        };

        const handelBlur = () => {
            if (brVal) {
                EventService.publish("keyboard.hide");
                focusRef.current = false;
            } else {
                ref.current.focus();
                setBrVal(true);
                focusRef.current = true;
            }
        };

        const isValid = newValue => {
            if (isNaN(newValue) && newValue !== "-") return false;

            if (decimalsAllowed) {
                if (String(newValue).split(".")[1] && String(newValue).split(".")[1].length > decimalsAllowed)
                    return false;
            }

            if (sizeRange) {
                let max = sizeRange[1];
                if (max !== -1 && String(newValue).split(".")[0].length > max) {
                    return false;
                }
            }

            if (minMax) {
                let max = minMax[1];
                if (newValue > max) return false;
            }

            return true;
        };

        const { openKeyboard } = useKeyboard(value, handleInputChange);
        return (
            <div className={`input-field-sec ${errorMsg ? "error-field" : ""} ${containerClass || ""}`}>
                <MuiTextField
                    inputRef={ref}
                    helperText={label}
                    value={value}
                    onChange={e => handleInputChange(e.target.value)}
                    onFocus={() => {
                        focusRef.current = true;
                        showKeyboard &&
                        openKeyboard({
                            layoutName: virtualKeyboardLayout || "numbers",
                            virtualKeyboardLang: virtualKeyboardLang
                        })
                    }}
                    {...restProps}
                    onBlur={handelBlur}
                    type="text"
                />
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default NumberField;
